var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_c('div',{staticClass:"whiteBg pl-2 pt-2 pr-2 pb-2"},[_c('v-progress-circular',{staticClass:"pageProgress",attrs:{"indeterminate":"","size":_vm.size,"width":Number(_vm.width),"aria-label":"Loading.."}},[_c('center',[_vm._v(_vm._s(_vm.message))])],1)],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }